import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore('themeStore', () => {
  const theme = ref<string>('light')

  function setTheme(newTheme: string) {
    theme.value = newTheme
  }

  return {
    theme,
    setTheme
  }
})
